module.exports = __webpack_public_path__ + "img/LM321.21564042.jpg";